export function useAnalytics() {
  const config = useRuntimeConfig();

  const emit = (eventName: string, params: Record<string, any> = {}) => {
    if (typeof window === "undefined") return;
    const gtag = (window as any).gtag;
    if (typeof gtag !== "function") return;
    gtag("event", eventName, params);
  };

  const trackBookFormSubmit = () => {
    emit("form_submit", {
      form_name: "book_online",
      page_path: "/book",
    });

    // Fire Google Ads conversion on submit click.
    trackConversion();
  };

  const trackConversion = () => {
    const gAdsId = config.public.gAdsId;
    const gAdsConversionLabel = config.public.gAdsConversionLabel;
    if (!gAdsId || !gAdsConversionLabel) return;

    emit("conversion", {
      send_to: `${gAdsId}/${gAdsConversionLabel}`,
    });
  };

  return {
    trackBookFormSubmit,
    trackConversion,
  };
}
